import React from 'react'

import { Title3 } from '@thriveglobal/thrive-ui-lib'
import { COLORS } from '@enums/colors'
import { createPortal } from 'react-dom'
import {
  BackgroundOverlay,
  ModalContainer,
  BodyNoScroll,
  AssessmentsModalContainer,
  OverlayHeader,
} from './styles'
import { ReactComponent as CloseIcon } from '@images/icon-close.svg'

export enum ModalTypes {
  default = 'default',
  assessment = 'assessment',
}

type Props = {
  overlayTilte?: string
  backgroundOverlayColor?: string
  type?: ModalTypes
  onClose?: () => void
}

const isDefaultModal = (type: ModalTypes) => type === ModalTypes.default
const isAssessmentModal = (type: ModalTypes) => type === ModalTypes.assessment

const Modal: React.FC<Props> = ({
  children,
  overlayTilte,
  backgroundOverlayColor,
  type = ModalTypes.default,
  onClose,
}) =>
  createPortal(
    <React.Fragment>
      <BodyNoScroll />
      <BackgroundOverlay
        aria-hidden="false"
        data-testid="modal-overlay"
        backgroundColor={backgroundOverlayColor}
      >
        <OverlayHeader>
          {overlayTilte && <Title3 color={COLORS.white}>{overlayTilte}</Title3>}
          {onClose && (
            <CloseIcon data-testid="modal-close-overlay" onClick={onClose} />
          )}
        </OverlayHeader>
        {isDefaultModal(type) && <ModalContainer>{children}</ModalContainer>}
        {isAssessmentModal(type) && (
          <AssessmentsModalContainer>{children}</AssessmentsModalContainer>
        )}
      </BackgroundOverlay>
    </React.Fragment>,
    document.body
  )

export default Modal
